export default __webpack_public_path__ + "static/media/sponsor-icon.d687f2aa.svg";